import { ApiClient } from "@ucl/library";

export interface InviteTokenResponse {
  auth0OrganizationId: string;
  emailAddress: string;
}

class InviteApiClient {
  private _apiClient: ApiClient;

  constructor(apiClient: ApiClient) {
    this._apiClient = apiClient;
  }

  /**
   * Validates an invite token and returns organization and email information
   */
  validateInviteToken = async (token: string): Promise<InviteTokenResponse> => {
    return this._apiClient.get<InviteTokenResponse>(`api/invite/token/${token}`);
  };
}

export default InviteApiClient;
